// extracted by mini-css-extract-plugin
export default {"wrapper":"startViev_wrapper__3pGX0","image":"startViev_image__Iot-0","special":"startViev_special__BIQce","inside":"startViev_inside__aIyen","bigInfo":"startViev_bigInfo__Rx9uF"};